/**
 * TODO: I18n for this page.
 */

import * as React from "react";
import { useTimeout, BigCenterMessage, Loading } from "@granular/fabric3-core";
import { useLocation } from "react-router-dom";

const NotFound: React.FC = () => {
  const location = useLocation();

  const [waitedForLoading, setWaitedForLoading] = React.useState(false);
  useTimeout(() => setWaitedForLoading(true), 750);
  if (!waitedForLoading) {
    return <Loading />;
  }

  return (
    <BigCenterMessage
      heading={"I'm sorry but I could not find anything at that route."}
      color="danger"
    >
      <p
        // A true shame that Bootstrap doesn't ship with these classes..
        style={{
          opacity: "0.5",
          overflowWrap: "anywhere",
          wordWrap: "break-word",
        }}
      >
        {location.pathname}
      </p>
    </BigCenterMessage>
  );
};

export default NotFound;
